import PayoutSettingsPage from "./payoutSettings";

export default PayoutSettingsPage;